/** Returns true if the given page key is allowed by the IDP rights object.
 *  Fail-open: missing keys / null paginas → visible. Explicit `false` → hidden. */
export function isPageAllowed(paginas, pageKey) {
  if (!paginas || typeof paginas !== 'object') return true;
  return paginas[pageKey] !== false;
}
